import React from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';

import Loader from 'components/layout/Loader';
import NoSubcompanies from 'components/layout/NoSubcompanies';

export const StatesReadySwitch = {
  LOADING: 'LOADING',
  OK: 'OK',
  SELECT_COMPANY: 'SELECT_COMPANY',
  SELECT_SUBCOMPANY: 'SELECT_SUBCOMPANY',
  // feature/acceso-subcompanias: a subcompany the user may not enter
  REDIRECT_SUBCOMPANY: 'REDIRECT_SUBCOMPANY',
  NO_SUBCOMPANIES: 'NO_SUBCOMPANIES',
};

const ReadySwitch = ({ Element, state, ...props }) => {
  const toCompanies = `/`;
  const toSubcompanies = `/companies/${props.companyId}`;

  return {
    [StatesReadySwitch.LOADING]: <Loader />,
    [StatesReadySwitch.OK]: <Element />,
    [StatesReadySwitch.SELECT_COMPANY]: <Redirect to={toCompanies} />,
    [StatesReadySwitch.SELECT_SUBCOMPANY]: <Redirect to={toSubcompanies} />,
    [StatesReadySwitch.REDIRECT_SUBCOMPANY]: <Redirect to={props.redirectTo || toSubcompanies} />,
    [StatesReadySwitch.NO_SUBCOMPANIES]: <NoSubcompanies />,
  }[state];
};

export default ReadySwitch;



// WEBPACK FOOTER //
// src/components/layout/ReadySwitch.js